
import Vue from "vue";
import AppFileUpload from "@/components/FileUpload.vue";
import AppUploadScanAnimation from "@/components/inbox/UploadScanAnimation.vue";
import { HttpError } from "@/utils/services/http-error";
import { humanReadableByteCount } from "@/utils/strings";
import { InboxUpload } from "@/utils/inbox/inbox-upload-job";

const MAX_FILES = 20;

export default Vue.extend({
	data(){
		return {
			files: [] as File[],
			uploadJob: InboxUpload,
			allowedExtensions: ["pdf", "jpg", "jpeg", "png"],
			maxSize: 15e6
		};
	},
	computed: {
		sending():boolean{
			return this.uploadJob.isSending;
		}
	},
	methods: {
		addFile(file:File){
			if (this.files.length >= MAX_FILES) {
				this.$wf.notify(this.$ct("max-files-reached", {count: MAX_FILES}), "warning", 5000, "exclamation-triangle");
				return;
			}
			if (this.files.some(f=>f.name == file.name && f.size == file.size)) return;
			this.files.push(file);
		},
		removeFile(index:number){
			this.files.splice(index, 1);
		},
		clearFiles(){
			this.files = [];
		},
		fileKind(file:File):string{
			return file.name.toLowerCase().endsWith(".pdf") ? "pdf" : "image";
		},
		fileIcon(file:File):string{
			return file.name.toLowerCase().endsWith(".pdf") ? "file-pdf" : "file-image";
		},
		prettySize(size:number):string{
			return humanReadableByteCount(size);
		},
		async upload(){
			if (!this.files.length) return;
			try{
				await this.uploadJob.start(this.files);
				this.files = [];
				this.close();
			}catch(err){
				let hErr = err as HttpError;
				hErr.dontShow = true;
				this.$wf.notify(hErr.getText(), "danger", 5000, "exclamation-triangle");
			}
		},
		close(){
			this.$emit("close");
		}
	},
	components: {
		AppFileUpload,
		AppUploadScanAnimation
	},
	i18nEx: {
		componentPrefix: "components.winbox"
	}
});
